import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";
import L from "leaflet";
import { 
  MapPin, Truck, Clock, Search, User, Phone, Mail, Calendar, 
  MessageSquare, FileText, CreditCard, Banknote, X, CheckCircle, 
  Wallet, ArrowLeft, Ticket, AlertCircle 
} from "lucide-react";

import { db as database, auth } from "./firebase";
// Cập nhật import update thay vì set
import { ref, update, onValue } from "firebase/database";
import { onAuthStateChanged } from "firebase/auth";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const SHOP_LOCATION = [10.806568671481422, 106.71315486968544];
const BANK_INFO = {
  bankId: "MBB",
  accountNo: "0975341611",
  accountName: "NGUYEN LE MY ANH",
};

const HO_CHI_MINH_WARDS = [
  "Phường Sài Gòn", "Phường Tân Định", "Phường Bến Thành", "Phường Cầu Ông Lãnh", "Phường Bàn Cờ", 
  "Phường Xuân Hòa", "Phường Nhiêu Lộc", "Phường Xóm Chiếu", "Phường Khánh Hội", "Phường Vĩnh Hội", 
  "Phường Chợ Quán", "Phường An Đông", "Phường Chợ Lớn", "Phường Bình Tây", "Phường Bình Tiên", 
  "Phường Bình Phú", "Phường Phú Lâm", "Phường Tân Thuận", "Phường Phú Thuận", "Phường Tân Mỹ", 
  "Phường Tân Hưng", "Phường Chánh Hưng", "Phường Phú Định", "Phường Bình Đông", "Phường Diên Hồng", 
  "Phường Vườn Lài", "Phường Hòa Hưng", "Phường Minh Phụng", "Phường Bình Thới", "Phường Hòa Bình", 
  "Phường Phú Thọ", "Phường Đông Hưng Thuận", "Phường Trung Mỹ Tây", "Phường Tân Thới Hiệp", 
  "Phường Thới An", "Phường An Phú Đông", "Phường An Lạc", "Phường Bình Tân", "Phường Tân Tạo", 
  "Phường Bình Trị Đông", "Phường Bình Hưng Hòa", "Phường Gia Định", "Phường Bình Thạnh", 
  "Phường Bình Lợi Trung", "Phường Thạnh Mỹ Tây", "Phường Bình Quới", "Phường Hạnh Thông", 
  "Phường An Nhơn", "Phường Gò Vấp", "Phường An Hội Đông", "Phường Thông Tây Hội", "Phường An Hội Tây", 
  "Phường Đức Nhuận", "Phường Cầu Kiệu", "Phường Phú Nhuận", "Phường Tân Sơn Hòa", "Phường Tân Sơn Nhất", 
  "Phường Tân Hòa", "Phường Bảy Hiền", "Phường Tân Bình", "Phường Tân Sơn", "Phường Tây Thạnh", 
  "Phường Tân Sơn Nhì", "Phường Phú Thọ Hòa", "Phường Tân Phú", "Phường Phú Thạnh", "Phường Hiệp Bình", 
  "Phường Thủ Đức", "Phường Tam Bình", "PhManual Linh Xuân", "Phường Tăng Nhơn Phú", "Phường Long Bình", 
  "Phường Long Phước", "Phường Long Trường", "Phường Cát Lái", "Phường Bình Trưng", "Phường Phước Long", 
  "An Khánh", "Phường Đông Hòa", "Phường Dĩ An", "Phường Tân Đông Hiệp", "Phường An Phú", 
  "Phường Bình Hòa", "Phường Lái Thiêu", "Phường Thuận An", "Phường Thuận Giao", "Phường Thủ Dầu Một", 
  "Phường Phú Lợi", "Phường Chánh Hiệp", "Phường Bình Dương", "Phường Hòa Lợi", "Phường Phú An", 
  "Phường Tây Nam", "Phường Long Nguyên", "Phường Bến Cát", "Phường Chánh Phú Hòa", "Phường Vĩnh Tân", 
  "Phường Bình Cơ", "Phường Tân Uyên", "Phường Tân Hiệp", "Phường Tân Khánh", "Phường Vũng Tàu", 
  "Phường Tam Thắng", "Phường Rạch Dừa", "Phường Phước Thắng", "Phường Long Hương", "Phường Bà Rịa", 
  "Phường Tam Long", "Phường Tân Hải", "Phường Tân Phước", "Phường Phú Mỹ", "Phường Tân Thành", 
  "Xã Vĩnh Lộc", "Xã Tân Vĩnh Lộc", "Xã Bình Lợi", "Xã Tân Nhựt", "Xã Bình Chánh", "Xã Hưng Long", 
  "Xã Bình Hưng", "Xã Bình Khánh", "Xã An Thới Đông", "Xã Cần Giờ", "Xã Củ Chi", "Xã Tân An Hội", 
  "Xã Thái Mỹ", "Xã An Nhơn Tây", "Xã Nhuận Đức", "Xã Phú Hòa Đông", "Xã Bình Mỹ", "Xã Đông Thạnh", 
  "Xã Hóc Môn", "Xã Xuân Thới Sơn", "Xã Bà Điểm", "Xã Nhà Bè", "Xã Hiệp Phước", "Xã Thường Tân", 
  "Xã Bắc Tân Uyên", "Xã Phú Giáo", "Xã Phước Hòa", "Xã Phước Thành", "Xã An Long", "Xã Trừ Văn Thố", 
  "Xã Bàu Bàng", "Xã Long Hòa", "Xã Thanh An", "Xã Dầu Tiếng", "Xã Minh Thạnh", "Xã Châu Pha", 
  "Xã Long Hải", "Xã Long Điền", "Xã Phước Hải", "Xã Đất Đỏ", "Xã Nghĩa Thành", "Xã Ngãi Giao", 
  "Xã Kim Long", "Xã Châu Đức", "Xã Bình Giã", "Xã Xuân Sơn", "Xã Hồ Tràm", "Xã Xuyên Mộc", 
  "Xã Hòa Hội", "Xã Bàu Lâm", "Đặc khu Côn Đảo", "Xã Bình Châu", "Xã Hòa Hiệp", "Xã Long Sơn", 
  "Xã Thạnh An", "Phường Thới Hòa"
].slice(0, 168);

export default function Thanhtoan() {
  const navigate = useNavigate();
  const location = useLocation();
  const [cart, setCart] = useState([]);
  const initialMethod = location.state?.chosenMethod || "cod";
  const [buyerInfo, setBuyerInfo] = useState({ name: "", phone: "", email: "", hideSender: "Không" });
  const [receiverInfo, setReceiverInfo] = useState({ name: "", phone: "", address: "", city: "TP Hồ Chí Minh", ward: "", deliveryDate: "", deliveryTime: "", message: "", note: "" });
  const [paymentMethod, setPaymentMethod] = useState(initialMethod);
  const [couponCode, setCouponCode] = useState("");
  const [discountAmount, setDiscountAmount] = useState(0);
  const [customerLoc, setCustomerLoc] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [deliveryInfo, setDeliveryInfo] = useState({ distance: 0, time: 0, shipFee: 0 });
  const [showInvoice, setShowInvoice] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Tạo mã orderId thuần số nguyên thay vì chuỗi có chữ "FLO"
  const [orderId] = useState(() => Math.floor(100000 + Math.random() * 900000));
  
  const [verificationState, setVerificationState] = useState("idle");
  const [toast, setToast] = useState({ show: false, message: "", type: "success" });
  const [wardSearch, setWardSearch] = React.useState(receiverInfo.ward || "");
  const [showWardDropdown, setShowWardDropdown] = React.useState(false);
  const filteredWards = HO_CHI_MINH_WARDS.filter((ward) =>
    ward.toLowerCase().includes(wardSearch.toLowerCase())
  );
  const [showSenderDropdown, setShowSenderDropdown] = React.useState(false);
  const [hoveredSenderIndex, setHoveredSenderIndex] = React.useState(null);

  const SENDER_OPTIONS = [
    { value: "Không", label: "Không - Hiển thị tên người gửi cho người nhận" },
    { value: "Có", label: "Có - Gửi tặng bí mật (Ẩn danh hoàn toàn)" }
  ];

  const currentSenderLabel = SENDER_OPTIONS.find(opt => opt.value === buyerInfo.hideSender)?.label || "Không - Hiển thị tên người gửi cho người nhận";
  
  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
  };

  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,400&family=Pinyon+Script&family=Montserrat:wght@300;400;500;600&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }, []);

  useEffect(() => {
    if (toast.show) {
      const timer = setTimeout(() => {
        setToast({ ...toast, show: false });
      }, 3500);
      return () => clearTimeout(timer);
    }
  }, [toast.show]);

  useEffect(() => {
    const savedCart = JSON.parse(localStorage.getItem("sellixy_cart")) || [];
    if (savedCart.length === 0) navigate("/");
    setCart(savedCart);
  }, [navigate]);

  useEffect(() => {
    if (verificationState !== "checking") return;
    const orderRef = ref(database, `orders/${orderId}`);
    const unsubscribe = onValue(orderRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        if (data.status === "verified_success") {
          setVerificationState("success");
          localStorage.removeItem("sellixy_cart");
          showToast("Thanh toán thành công!", "success");
          setTimeout(() => navigate("/"), 4000);
        } 
        else if (
          data.status === "payment_rejected" || 
          data.status === "verified_failed" || 
          data.status === "payment_failed" || 
          data.status === "rejected"
        ) {
          setVerificationState("failed");
          showToast("Thanh toán thất bại!", "error");
          setTimeout(() => { setVerificationState("idle"); }, 5000);
        }
      }
    });
    return () => unsubscribe();
  }, [verificationState, orderId, navigate]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const isSuccess = query.get("success");
    const isCanceled = query.get("canceled");
    const returnedOrderId = query.get("orderId");

    if ((isSuccess || isCanceled) && returnedOrderId) {
      // Đợi Firebase Auth nhận diện xong tài khoản người dùng để lấy UID chính xác
      const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
        const currentUid = user ? user.uid : "khach_vang_lai";
        const updates = {};

        if (isSuccess) {
          setVerificationState("success");
          localStorage.removeItem("sellixy_cart");
          window.dispatchEvent(new Event("storage"));
          // Đồng bộ trạng thái verified_success lên cả 2 nơi bằng UID chuẩn
          updates[`orders/${returnedOrderId}/status`] = "verified_success";
          if (currentUid !== "khach_vang_lai") {
            updates[`user_orders/${currentUid}/${returnedOrderId}/status`] = "verified_success";
          }

          update(ref(database), updates)
            .then(() => {
              showToast("Thanh toán thành công! Hệ thống đã ghi nhận đơn hàng.", "success");
              setTimeout(() => navigate("/"), 3000);
            })
            .catch((error) => {
              console.error("Lỗi tự động cập nhật đơn hàng:", error);
            });
        }

        if (isCanceled) {
          setVerificationState("failed");

          updates[`orders/${returnedOrderId}/status`] = "payment_failed";
          if (currentUid !== "khach_vang_lai") {
            updates[`user_orders/${currentUid}/${returnedOrderId}/status`] = "payment_failed";
          }

          update(ref(database), updates).then(() => {
            showToast("Thanh toán đã bị hủy!", "error");
            setTimeout(() => {
              setVerificationState("idle");
              navigate("/thanh-toan", { replace: true });
            }, 3000);
          });
        }
      });

      return () => unsubscribeAuth();
    }
  }, [location.search, navigate]);

  const cartTotal = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const finalTotal = Math.max(0, cartTotal + deliveryInfo.shipFee - discountAmount);

  const saveOrderToFirebase = (customStatus) => {
    const userId = auth.currentUser ? auth.currentUser.uid : "khach_vang_lai";

    const newOrder = {
      id: orderId,
      userId: userId,
      buyer: buyerInfo,
      receiver: receiverInfo,
      items: cart,
      total: finalTotal,
      discount: discountAmount,
      shipFee: deliveryInfo.shipFee,
      paymentMethod: paymentMethod,
      status: customStatus,
      createdAt: new Date().toISOString()
    };

    // Chuẩn bị payload để cập nhật vào 2 đường dẫn trong db (cho admin và cho khách tracking)
    const updates = {};
    updates[`orders/${orderId}`] = newOrder;
    
    if (userId !== "khach_vang_lai") {
      updates[`user_orders/${userId}/${orderId}`] = newOrder;
    }

    const rootRef = ref(database);
    update(rootRef, updates).catch((err) => {
      console.error("Lỗi Firebase:", err);
      showToast("Lỗi đồng bộ dữ liệu hệ thống!", "error");
    });
  };

  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    let shipFee = 0;
    if (distance > 2) {
      shipFee = Math.round((distance - 2) * 5000);
      shipFee = Math.ceil(shipFee / 1000) * 1000;
    }
    const time = Math.round((distance / 20) * 60 + 15);
    setDeliveryInfo({ distance: distance.toFixed(1), time, shipFee });
  };

  let typingTimeout;
  const handleAddressChange = (value) => {
    setReceiverInfo({ ...receiverInfo, address: value });
    if (typingTimeout) clearTimeout(typingTimeout);
    if (value.length > 3) {
      typingTimeout = setTimeout(async () => {
        try {
          const res = await fetch(`https://photon.komoot.io/api/?q=${encodeURIComponent(value)}&limit=5`);
          if (res.ok) {
            const data = await res.json();
            const formattedData = data.features.map(f => ({
              display_name: [f.properties.name, f.properties.street, f.properties.district, f.properties.city, f.properties.country].filter(Boolean).join(", "),
              lat: f.geometry.coordinates[1],
              lon: f.geometry.coordinates[0]
            }));
            setSuggestions(formattedData);
          }
        } catch (err) {
          console.error("Lỗi API");
        }
      }, 500);
    } else {
      setSuggestions([]);
    }
  };

  const selectSuggestion = (item) => {
    const newLoc = [parseFloat(item.lat), parseFloat(item.lon)];
    setReceiverInfo({ ...receiverInfo, address: item.display_name });
    setCustomerLoc(newLoc);
    setSuggestions([]);
    calculateDistance(SHOP_LOCATION[0], SHOP_LOCATION[1], newLoc[0], newLoc[1]);
  };

  function ChangeView({ center }) {
    const map = useMap();
    if (center) map.flyTo(center, 16);
    return null;
  }

  function MapEvents() {
    useMapEvents({
      click(e) {
        setCustomerLoc([e.latlng.lat, e.latlng.lng]);
        calculateDistance(SHOP_LOCATION[0], SHOP_LOCATION[1], e.latlng.lat, e.latlng.lng);
        setSuggestions([]);
      },
    });
    return customerLoc ? <Marker position={customerLoc} /> : null;
  }

  const handleApplyCoupon = () => {
    if (couponCode.trim().toUpperCase() === "FLORAISON") {
      setDiscountAmount(50000);
      showToast("Áp dụng mã thành công! Bạn được giảm 50.000đ", "success");
    } else {
      showToast("Mã giảm giá không hợp lệ hoặc đã hết hạn!", "error");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const phoneRegex = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!phoneRegex.test(buyerInfo.phone)) {
      return showToast("Số điện thoại người mua phải gồm đúng 10 chữ số!", "error");
    }

    if (!emailRegex.test(buyerInfo.email)) {
      return showToast("Địa chỉ email không hợp lệ (Phải chứa kí tự '@')!", "error");
    }

    if (!phoneRegex.test(receiverInfo.phone)) {
      return showToast("Số điện thoại người nhận phải gồm đúng 10 chữ số!", "error");
    }

    if (!receiverInfo.ward) {
      return showToast("Vui lòng chọn Phường / Xã để giao hoa!", "error");
    }

    // Bắt đầu bật trạng thái Loading
    setIsSubmitting(true);

    if (paymentMethod === "transfer") {
      try {
        saveOrderToFirebase("awaiting_payment");

        const res = await fetch("https://my-flower-app-backend.onrender.com/create-payment-link", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            orderId,
            amount: finalTotal,
            buyerInfo,
            receiverInfo,
            cart,
          }),
        });

        const data = await res.json();

        if (!res.ok || !data.checkoutUrl) {
          throw new Error(data?.error || "Không tạo được thanh toán");
        }

        // Chuyển hướng thành công thì không cần tắt Loading để tránh chớp giật giao diện
        window.location.href = data.checkoutUrl;
        return;
      } catch (err) {
        console.error(err);
        showToast("Không tạo được thanh toán", "error");
        setIsSubmitting(false); // Tắt Loading khi có lỗi
        return;
      }
    }

    
  };

  const qrUrl = `https://img.vietqr.io/image/${BANK_INFO.bankId}-${BANK_INFO.accountNo}-compact2.png?amount=${finalTotal}&addInfo=Thanh toan ${orderId}&accountName=${encodeURIComponent(BANK_INFO.accountName)}`;

  // Đoạn code render giao diện UI bên dưới giữ nguyên...
  return (
    <div style={styles.container}>
      <style>{`
        .btn-luxury-back {
          background: none; border: none; color: #666; font-size: 14px; font-weight: 500;
          display: flex; alignItems: center; gap: 6px; cursor: pointer; padding: 0;
          transition: color 0.3s ease;
        }
        .btn-luxury-back:hover { color: #000000 !important; }
        
        .input-luxury-field:focus, .select-luxury-field:focus, .textarea-luxury-field:focus {
          border-color: #000000 !important;
          background-color: #fff !important;
          box-shadow: 0 0 0 3px rgba(74, 90, 58, 0.05);
        }
        
        .btn-luxury-action {
          background-color: #222 !important; color: #fff !important;
          transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .btn-luxury-action:hover {
          background-color: #000000 !important;
          transform: translateY(-1px);
          box-shadow: 0 8px 24px rgba(74, 90, 58, 0.2) !important;
        }

        .btn-luxury-outline {
          background: transparent !important; border: 1px solid #000000 !important; color: #000000 !important;
          transition: all 0.3s ease;
        }
        .btn-luxury-outline:hover { background-color: #000000 !important; color: #fff !important; }

        @media (max-width: 992px) {
          .checkout-layout-flex { flex-direction: column !important; }
          .summary-sticky-column { position: static !important; width: 100% !important; }
        }
        @media (max-width: 576px) {
          .row-split-mobile { grid-template-columns: 1fr !important; }
        }
      `}</style>

      <AnimatePresence>
        {toast.show && (
          <motion.div 
            initial={{ opacity: 0, x: 50, y: -20 }} 
            animate={{ opacity: 1, x: 0, y: 0 }} 
            exit={{ opacity: 0, x: 50 }} 
            transition={{ type: "spring", stiffness: 300, damping: 25 }} 
            style={{ ...styles.toastNotification, backgroundColor: toast.type === "success" ? "#000000" : "#E53935" }}
          >
            {toast.type === "success" ? <CheckCircle size={18} color="#fff" /> : <AlertCircle size={18} color="#fff" />}
            <span style={{ fontSize: "14px", fontWeight: "500" }}>{toast.message}</span>
            <button type="button" onClick={() => setToast({ ...toast, show: false })} style={styles.toastCloseBtn}>
              <X size={14} color="#fff" />
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {verificationState !== "idle" && (
          <div style={{ ...styles.modalOverlay, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)" }}>
            <motion.div initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.9, opacity: 0 }} style={styles.verificationCard}>
              {verificationState === "checking" && (
                <>
                  <div style={{ width: "40px", height: "40px", border: "3px solid rgba(74, 90, 58, 0.1)", borderTop: "3px solid #000000", borderRadius: "50%", margin: "0 auto 20px", animation: "spin 1s linear infinite" }} />
                  <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                  <h3 style={styles.modalStatusTitle}>Đang xác thực giao dịch</h3>
                  <p style={styles.modalStatusDesc}>Hệ thống đang xác thực tự động giao dịch cho đơn hàng <b>{orderId}</b>. Vui lòng giữ nguyên màn hình trong giây lát.</p>
                </>
              )}
              {verificationState === "success" && (
                <>
                  <CheckCircle size={48} color="#000000" style={{ margin: "0 auto 15px" }} />
                  <h3 style={{ ...styles.modalStatusTitle, color: "#000000" }}>Thanh toán thành công!</h3>
                  <p style={styles.modalStatusDesc}>Cảm ơn bạn đã lựa chọn Floraison. Đang tự động điều hướng quay trở về trang chủ...</p>
                </>
              )}
              {verificationState === "failed" && (
                <>
                  <AlertCircle size={48} color="#E53935" style={{ margin: "0 auto 15px" }} />
                  <h3 style={{ ...styles.modalStatusTitle, color: "#E53935" }}>Giao dịch thất bại!</h3>
                  <p style={styles.modalStatusDesc}>Thanh toán chưa được xác nhận. Vui lòng kiểm tra lại thông tin chuyển khoản hoặc liên hệ bộ phận hỗ trợ Floraison.</p>
                </>
              )}
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      <div style={styles.topBackBar}>
        <button onClick={() => navigate("/gio-hang-cua-ban")} className="btn-luxury-back">
          <ArrowLeft size={16} /> Quay lại giỏ hàng
        </button>
      </div>

      <div style={styles.contentWrap}>
        <form onSubmit={handleSubmit} style={styles.checkoutLayout} className="checkout-layout-flex">
          
          <div style={styles.formSection}>
            <div style={{ textAlign: 'center', marginBottom: 30 }}>
              <span style={styles.scriptSubtitle}>Floraison</span>
              <h2 style={styles.mainTitle}>Thông tin đặt hàng</h2>
            </div>

            <h3 style={styles.subTitle}>1. Thông tin người mua</h3>
            <div style={styles.formGrid}>
              <div style={styles.inputGroup}>
                <label style={styles.fieldLabel}>Họ tên người mua *</label>
                <div style={styles.inputWrapper}>
                  <User size={16} color="#000000" style={styles.fieldIcon} />
                  <input required className="input-luxury-field" style={styles.inputStyle} placeholder="Nhập họ và tên người mua" value={buyerInfo.name} onChange={(e) => setBuyerInfo({...buyerInfo, name: e.target.value})} />
                </div>
              </div>
              <div style={styles.formRowSplit} className="row-split-mobile">
                <div style={styles.inputGroup}>
                  <label style={styles.fieldLabel}>Số điện thoại *</label>
                  <div style={styles.inputWrapper}>
                    <Phone size={16} color="#000000" style={styles.fieldIcon} />
                    <input required type="tel" maxLength={10} className="input-luxury-field" style={styles.inputStyle} placeholder="Ví dụ: 0901234567" value={buyerInfo.phone} onChange={(e) => setBuyerInfo({...buyerInfo, phone: e.target.value})} />
                  </div>
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.fieldLabel}>Email người mua *</label>
                  <div style={styles.inputWrapper}>
                    <Mail size={16} color="#000000" style={styles.fieldIcon} />
                    <input required type="email" className="input-luxury-field" style={styles.inputStyle} placeholder="tên@email.com" value={buyerInfo.email} onChange={(e) => setBuyerInfo({...buyerInfo, email: e.target.value})} />
                  </div>
                </div>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.fieldLabel}>Ẩn thông tin người gửi</label>
                <div style={styles.dropdownWrapper}>
                  <input
                    type="text"
                    readOnly
                    className="select-luxury-field"
                    style={{ ...styles.selectStyle, paddingLeft: "12px", cursor: "pointer" }}
                    value={currentSenderLabel}
                    onClick={() => setShowSenderDropdown(!showSenderDropdown)}
                    onBlur={() => setTimeout(() => setShowSenderDropdown(false), 200)}
                  />
                  {showSenderDropdown && (
                    <ul style={styles.wardDropdownList}>
                      {SENDER_OPTIONS.map((option, i) => (
                        <li
                          key={i}
                          style={{
                            ...styles.wardDropdownItem,
                            background: hoveredSenderIndex === i ? "#000000" : "#ffffff",
                            color: hoveredSenderIndex === i ? "#ffffff" : "#333333",
                          }}
                          onMouseEnter={() => setHoveredSenderIndex(i)}
                          onMouseLeave={() => setHoveredSenderIndex(null)}
                          onMouseDown={() => {
                            setBuyerInfo({ ...buyerInfo, hideSender: option.value });
                            setShowSenderDropdown(false);
                          }}
                        >
                          {option.label}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>

            <h3 style={{ ...styles.subTitle, marginTop: 40 }}>2. Thông tin người nhận & Địa điểm giao hoa</h3>
            <div style={styles.formGrid}>
              <div style={styles.formRowSplit} className="row-split-mobile">
                <div style={styles.inputGroup}>
                  <label style={styles.fieldLabel}>Họ tên người nhận *</label>
                  <div style={styles.inputWrapper}>
                    <User size={16} color="#000000" style={styles.fieldIcon} />
                    <input required className="input-luxury-field" style={styles.inputStyle} placeholder="Nhập họ tên người nhận hoa" value={receiverInfo.name} onChange={(e) => setReceiverInfo({...receiverInfo, name: e.target.value})} />
                  </div>
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.fieldLabel}>Số điện thoại người nhận *</label>
                  <div style={styles.inputWrapper}>
                    <Phone size={16} color="#000000" style={styles.fieldIcon} />
                    <input required type="tel" maxLength={10} className="input-luxury-field" style={styles.inputStyle} placeholder="Số điện thoại nhận hoa" value={receiverInfo.phone} onChange={(e) => setReceiverInfo({...receiverInfo, phone: e.target.value})} />
                  </div>
                </div>
              </div>
              <div style={styles.formRowSplit} className="row-split-mobile">
                <div style={styles.inputGroup}>
                  <label style={styles.fieldLabel}>Thành phố</label>
                  <input readOnly style={{...styles.inputStyle, background: "#f5f5f7", color: "#666", paddingLeft: 15, border: "1px solid #e1e1e7"}} value={receiverInfo.city} />
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.fieldLabel}>Phường / Xã *</label>
                  <div style={styles.dropdownWrapper}>
                    <input
                      type="text"
                      required
                      placeholder="Nhập thông tin Phường/Xã..."
                      className="select-luxury-field"
                      style={{ ...styles.selectStyle, paddingLeft: "12px" }}
                      value={wardSearch}
                      onChange={(e) => {
                        setWardSearch(e.target.value);
                        setShowWardDropdown(true);
                        setReceiverInfo({ ...receiverInfo, ward: "" }); 
                      }}
                      onFocus={() => setShowWardDropdown(true)}
                      onBlur={() => setTimeout(() => setShowWardDropdown(false), 200)} 
                    />
                    {showWardDropdown && filteredWards.length > 0 && (
                      <ul style={styles.wardDropdownList}>
                        {filteredWards.map((ward, i) => (
                          <li
                            key={i}
                            className="btn-luxury-outline" 
                            style={{
                              ...styles.wardDropdownItem,
                              border: "none",
                              textTransform: "none",
                              letterSpacing: "normal",
                              borderRadius: "0px",
                              display: "block",
                              width: "100%",
                              boxSizing: "border-box"
                            }}
                            onMouseDown={() => {
                              setWardSearch(ward);
                              setReceiverInfo({ ...receiverInfo, ward: ward });
                              setShowWardDropdown(false);
                            }}
                          >
                            {ward}
                          </li>
                        ))}
                      </ul>
                    )}
                    {showWardDropdown && wardSearch && filteredWards.length === 0 && (
                      <ul style={styles.wardDropdownList}>
                        <li style={{ ...styles.wardDropdownItem, color: "#999", cursor: "default" }}>
                          Không tìm thấy kết quả phù hợp
                        </li>
                      </ul>
                    )}
                  </div>
                </div>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.fieldLabel}>Địa chỉ chi tiết (Số nhà + Tên đường) *</label>
                <div style={{ position: "relative" }}>
                  <div style={styles.searchContainer}>
                    <Search size={16} color="#000000" />
                    <input required className="input-luxury-field" style={styles.inputClean} placeholder="Nhập thông tin số nhà, tên đường" value={receiverInfo.address} onChange={(e) => handleAddressChange(e.target.value)} />
                  </div>
                  <AnimatePresence>
                    {suggestions.length > 0 && (
                      <motion.ul initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} style={styles.suggestionBox}>
                        {suggestions.map((item, idx) => (
                          <li key={idx} style={styles.suggestionItem} onClick={() => selectSuggestion(item)}>
                            <MapPin size={14} style={{ marginRight: 10, flexShrink: 0 }} color="#000000" />
                            <span style={styles.suggestionText}>{item.display_name}</span>
                          </li>
                        ))}
                      </motion.ul>
                    )}
                  </AnimatePresence>
                </div>
              </div>
              
              <div style={styles.mapWrapper}>
                <MapContainer center={SHOP_LOCATION} zoom={14} style={{ height: "100%", width: "100%" }}>
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  <ChangeView center={customerLoc} />
                  <Marker position={SHOP_LOCATION} icon={new L.Icon({ iconUrl: 'https://cdn-icons-png.flaticon.com/512/6104/6104868.png', iconSize: [40, 40] })} />
                  <MapEvents />
                </MapContainer>
              </div>

              {deliveryInfo.distance > 0 && (
                <div style={styles.deliveryBadge}>
                  <div style={styles.badgeItem}><Truck size={16} color="#000000"/> <span>Khoảng cách: <b>{deliveryInfo.distance} km</b></span></div>
                  <div style={styles.badgeItem}><Clock size={16} color="#000000"/> <span>Thời gian di chuyển nháp: <b>~{deliveryInfo.time} phút</b></span></div>
                </div>
              )}

              <div style={styles.formRowSplit} className="row-split-mobile">
                <div style={styles.inputGroup}>
                  <label style={styles.fieldLabel}>Ngày giao hàng *</label>
                  <div style={styles.inputWrapper}>
                    <Calendar size={16} color="#000000" style={styles.fieldIcon} />
                    <input required type="date" className="input-luxury-field" style={styles.inputStyle} value={receiverInfo.deliveryDate} onChange={(e) => setReceiverInfo({...receiverInfo, deliveryDate: e.target.value})} />
                  </div>
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.fieldLabel}>Thời gian nhận hoa mong muốn *</label>
                  <div style={styles.inputWrapper}>
                    <Clock size={16} color="#000000" style={styles.fieldIcon} />
                    <input required type="text" placeholder="Ví dụ: Giao trước 9h Sáng, khoảng 14h-16h" className="input-luxury-field" style={styles.inputStyle} value={receiverInfo.deliveryTime} onChange={(e) => setReceiverInfo({...receiverInfo, deliveryTime: e.target.value})} />
                  </div>
                </div>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.fieldLabel}>Lời nhắn gửi người nhận hoa (In thiệp nghệ thuật)</label>
                <div style={styles.inputWrapper}>
                  <MessageSquare size={16} color="#000000" style={{...styles.fieldIcon, top: 15}} />
                  <textarea rows={2} className="textarea-luxury-field" style={styles.textareaStyle} placeholder="Nhập những lời chúc đong đầy yêu thương gửi tới người nhận..." value={receiverInfo.message} onChange={(e) => setReceiverInfo({...receiverInfo, message: e.target.value})} />
                </div>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.fieldLabel}>Lưu ý đặc biệt (Dành riêng cho Floraison chuẩn bị)</label>
                <div style={styles.inputWrapper}>
                  <FileText size={16} color="#000000" style={{...styles.fieldIcon, top: 15}} />
                  <textarea rows={2} className="textarea-luxury-field" style={styles.textareaStyle} placeholder="Ví dụ: Hoa bọc giấy kiếng, giao kín đáo, gọi điện trước khi đến 15 phút..." value={receiverInfo.note} onChange={(e) => setReceiverInfo({...receiverInfo, note: e.target.value})} />
                </div>
              </div>
            </div>

            <h3 style={{ ...styles.subTitle, marginTop: 40 }}>3. Hình thức thanh toán</h3>
            <div style={styles.paymentOptions}>
              <label style={paymentMethod === "cod" ? styles.paymentActive : styles.paymentLabel}>
                <input type="radio" name="method" value="cod" checked={paymentMethod === "cod"} onChange={() => setPaymentMethod("cod")} style={styles.radioHide} />
                <Banknote size={18} color={paymentMethod === "cod" ? "#000000" : "#666"} />
                <span>Thanh toán khi nhận hàng (COD)</span>
              </label>
              <label style={paymentMethod === "transfer" ? styles.paymentActive : styles.paymentLabel}>
                <input type="radio" name="method" value="transfer" checked={paymentMethod === "transfer"} onChange={() => setPaymentMethod("transfer")} style={styles.radioHide} />
                <CreditCard size={18} color={paymentMethod === "transfer" ? "#000000" : "#666"} />
                <span>Chuyển khoản nhanh qua Ngân hàng (Mã QR Tự Động)</span>
              </label>
            </div>
          </div>

          <div style={styles.summarySection} className="summary-sticky-column">
            <h3 style={styles.subTitle}>Chi tiết đơn hàng</h3>
            <div style={styles.cartItemsList}>
              {cart.map((item, index) => (
                <div key={item.id || index} style={styles.verticalOrderItem}>
                  <img src={item.img || "https://images.unsplash.com/photo-1561181286-d3fee7d55364?w=100"} alt={item.name} style={styles.productThumb} />
                  <div style={styles.productMainInfo}>
                    <span style={styles.productName}>{item.name}</span>
                    <span style={styles.productTypeBadge}>{item.isCustom ? "Hoa tự thiết kế" : "Hoa theo mẫu gốc"}</span>
                    <div style={styles.productPriceMeta}>
                      <span style={styles.productQuantityDisplay}>Số lượng: <b>{item.quantity}</b></span>
                      <strong style={styles.productPriceSum}>{(item.price * item.quantity).toLocaleString()}đ</strong>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div style={styles.divider}></div>
            
            <div style={styles.couponSectionWrap}>
              <div style={styles.couponInputInner}>
                <Ticket size={16} color="#000000" />
                <input type="text" className="input-luxury-field" style={styles.couponInputField} placeholder="Mã ưu đãi (FLORAISON)" value={couponCode} onChange={(e) => setCouponCode(e.target.value)} />
              </div>
              <button type="button" onClick={handleApplyCoupon} className="btn-luxury-outline" style={styles.btnApplyCoupon}>Áp dụng</button>
            </div>

            <div style={styles.divider}></div>

            <div style={styles.costLinesBreakdown}>
              <div style={styles.miniCartItem}>
                <span style={styles.labelMuted}>Tạm tính tiền hoa:</span>
                <span style={styles.costValue}>{cartTotal.toLocaleString()}đ</span>
              </div>
              {discountAmount > 0 && (
                <div style={{...styles.miniCartItem, color: "#000000"}}>
                  <span style={styles.labelMuted}>Ưu đãi đặc quyền:</span>
                  <span style={{ fontWeight: 500 }}>-{discountAmount.toLocaleString()}đ</span>
                </div>
              )}
              <div style={styles.miniCartItem}>
                <span style={styles.labelMuted}>Phí vận chuyển giao hoa:</span>
                <span style={styles.costValue}>{deliveryInfo.shipFee > 0 ? `${deliveryInfo.shipFee.toLocaleString()}đ` : "Miễn phí"}</span>
              </div>
            </div>

            <div style={{...styles.divider, margin: "20px 0 15px"}}></div>
            
            <div style={styles.totalContainer}>
              <span style={styles.totalFinalLabel}>Tổng thanh toán:</span>
              <span style={styles.totalAmount}>{finalTotal.toLocaleString()}đ</span>
            </div>

            <button 
              type="submit" 
              disabled={isSubmitting}
              className="btn-luxury-outline" 
              style={{
                ...styles.btnOrder,
                opacity: isSubmitting ? 0.6 : 1,
                cursor: isSubmitting ? "not-allowed" : "pointer"
              }}
            >
              {isSubmitting 
                ? (paymentMethod === "transfer" ? "Đang tạo mã thanh toán..." : "Đang xử lý...") 
                : "Xác nhận đơn hàng"}
            </button>
          </div>
        </form>
      </div>

      <AnimatePresence>
        {showInvoice && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} style={styles.modalOverlay}>
            <motion.div initial={{ scale: 0.95, y: 15 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.95, y: 15 }} style={styles.invoiceCard}>
              <button type="button" style={styles.closeBtn} onClick={() => setShowInvoice(false)}><X size={18} color="#666"/></button>
              
              <div style={styles.invoiceHeader}>
                <CheckCircle size={36} color="#000000" style={{ margin: "0 auto" }} />
                <h3 style={styles.invoiceModalTitle}>Đơn hàng chờ thanh toán</h3>
                <p style={{ color: "#666", fontSize: "13px", margin: 0 }}>Vui lòng thực hiện quét mã chuyển khoản chính xác</p>
              </div>

              <div style={styles.invoiceBody}>
                <div style={styles.invoiceRow}><span>Mã đơn hàng:</span> <strong>{orderId}</strong></div>
                <div style={styles.invoiceRow}><span>Tiền hàng:</span> <span>{cartTotal.toLocaleString()}đ</span></div>
                {discountAmount > 0 && <div style={{...styles.invoiceRow, color: "#000000"}}><span>Giảm giá:</span> <span>-{discountAmount.toLocaleString()}đ</span></div>}
                <div style={styles.invoiceRow}><span>Phí ship vận chuyển:</span> <span>{deliveryInfo.shipFee.toLocaleString()}đ</span></div>
                <div style={styles.invoiceRow}><span style={{fontWeight: "500"}}>Tổng thanh toán:</span> <strong style={{ color: "#000000", fontSize: "16px", fontWeight: "600" }}>{finalTotal.toLocaleString()}đ</strong></div>
                
                {paymentMethod === "transfer" ? (
                  <div style={styles.qrSection}>
                    <img src={qrUrl} alt="QR Thanh toán" style={styles.qrImage} />
                    <div style={styles.bankDetail}>
                      <p style={{margin: "4px 0"}}>Ngân hàng: <b>{BANK_INFO.bankId}</b></p>
                      <p style={{margin: "4px 0"}}>Số TK: <b>{BANK_INFO.accountNo}</b></p>
                      <p style={{margin: "4px 0"}}>Chủ TK: <b>{BANK_INFO.accountName}</b></p>
                    </div>
                  </div>
                ) : (
                  <div style={styles.qrSection}>
                    <div style={{ padding: "16px", background: "rgba(165, 0, 100, 0.03)", border: "1px solid rgba(165, 0, 100, 0.1)", borderRadius: "8px", width: "100%", color: "#a50064", boxSizing: "border-box" }}>
                    </div>
                  </div>
                )}
              </div>

              <button 
                type="button" 
                className="btn-luxury-action" 
                style={styles.btnDone} 
                onClick={() => {
                  setShowInvoice(false);
                  setVerificationState("checking");
                  saveOrderToFirebase("customer_paid_checking");
                }}
              >
                Tôi đã hoàn tất thanh toán
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

const styles = {
  container: {
    fontFamily: '"Montserrat", sans-serif',
    background: "#fae6f4",
    minHeight: "100vh",
    color: "#222",
    paddingBottom: 60
  },
  topBackBar: {
    maxWidth: 1140,
    margin: "0 auto",
    padding: "30px 20px 5px"
  },
  contentWrap: {
    maxWidth: 1140,
    margin: "0 auto",
    padding: "10px 20px"
  },
  checkoutLayout: {
    display: "flex",
    gap: "30px",
    alignItems: "flex-start"
  },
  formSection: {
    flex: "1 1 660px",
    background: "#fff",
    padding: "40px 35px",
    borderRadius: "4px",
    border: "1px solid rgba(74, 90, 58, 0.12)",
    boxShadow: "0 10px 30px rgba(0,0,0,0.02)",
    boxSizing: "border-box"
  },
  summarySection: {
    flex: "1 1 380px",
    background: "#fff",
    padding: "35px 30px",
    borderRadius: "4px",
    border: "1px solid rgba(74, 90, 58, 0.15)",
    boxShadow: "0 10px 30px rgba(0,0,0,0.02)",
    position: "sticky",
    top: "30px",
    boxSizing: "border-box"
  },
  scriptSubtitle: {
    fontFamily: '"Pinyon Script", cursive',
    fontSize: "36px",
    color: "#000000",
    display: "block",
    marginBottom: "-10px"
  },
  mainTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "28px",
    fontWeight: 400,
    color: "#222",
    margin: 0,
    letterSpacing: "0.5px"
  },
  subTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "20px",
    fontWeight: 500,
    marginBottom: "20px",
    color: "#222",
    borderBottom: "1px solid rgba(74, 90, 58, 0.1)",
    paddingBottom: "10px",
    letterSpacing: "0.5px"
  },
  formGrid: {
    display: "flex",
    flexDirection: "column",
    gap: "16px"
  },
  formRowSplit: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px"
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "6px"
  },
  fieldLabel: {
    fontSize: "12px",
    fontWeight: "500",
    color: "#555",
    textTransform: "uppercase",
    letterSpacing: "0.5px"
  },
  inputWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center"
  },
  fieldIcon: {
    position: "absolute",
    left: "14px",
    pointerEvents: "none",
    zIndex: 2
  },
  inputStyle: {
    width: "100%",
    height: "44px",
    border: "1px solid #eaeaea",
    borderRadius: "4px",
    fontSize: "14px",
    paddingLeft: "38px",
    paddingRight: "15px",
    outline: "none",
    background: "#fafafa",
    boxSizing: "border-box",
    fontFamily: "inherit",
    transition: "all 0.3s ease"
  },
  selectStyle: {
    width: "100%",
    height: "44px",
    border: "1px solid #eaeaea",
    borderRadius: "4px",
    fontSize: "13px",
    paddingLeft: "12px",
    outline: "none",
    background: "#fafafa",
    boxSizing: "border-box",
    fontFamily: "inherit",
    transition: "all 0.3s ease"
  },
  dropdownWrapper: {
    position: "relative",
    width: "100%",
  },
  wardDropdownList: {
    position: "absolute",
    top: "46px",
    left: 0,
    right: 0,
    background: "#ffffff",
    borderRadius: "4px",
    boxShadow: "0 10px 30px rgb(255, 255, 255)",
    zIndex: 1000,
    maxHeight: "200px",
    overflowY: "auto",
    padding: "4px 0",
    margin: 0,
    listStyle: "none",
    border: "1px solid #eaeaea",
  },
  wardDropdownItem: {
    padding: "10px 14px",
    cursor: "pointer",
    fontSize: "13px",
    color: "#ffffff",
    background: "#ffffff",
    transition: "all 0.3s ease",
  },
  textareaStyle: {
    width: "100%",
    border: "1px solid #eaeaea",
    borderRadius: "4px",
    fontSize: "13px",
    padding: "12px 12px 12px 38px",
    outline: "none",
    background: "#fafafa",
    boxSizing: "border-box",
    fontFamily: "inherit",
    resize: "none",
    transition: "all 0.3s ease"
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    background: "#fafafa",
    padding: "0 14px",
    borderRadius: "4px",
    border: "1px solid #eaeaea"
  },
  inputClean: {
    width: "100%",
    height: "44px",
    border: "none",
    background: "transparent",
    outline: "none",
    fontSize: "14px",
    paddingLeft: "0px",
    fontFamily: "inherit"
  },
  suggestionBox: {
    position: "absolute",
    top: "48px",
    left: 0,
    right: 0,
    background: "#fff",
    borderRadius: "4px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
    zIndex: 1000,
    padding: "6px 0",
    listStyle: "none",
    margin: 0,
    border: "1px solid rgba(74, 90, 58, 0.1)"
  },
  suggestionItem: {
    padding: "10px 14px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "13px",
    transition: "background 0.2s ease"
  },
  suggestionText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: "#555"
  },
  mapWrapper: {
    height: "240px",
    borderRadius: "4px",
    overflow: "hidden",
    border: "1px solid rgba(74, 90, 58, 0.1)",
    marginTop: "5px"
  },
  deliveryBadge: {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
    background: "rgba(74, 90, 58, 0.04)",
    padding: "12px 15px",
    borderRadius: "4px",
    border: "1px solid rgba(74, 90, 58, 0.08)"
  },
  badgeItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "13px",
    color: "#333"
  },
  paymentOptions: {
    display: "flex",
    flexDirection: "column",
    gap: "12px"
  },
  paymentLabel: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "14px 16px",
    borderRadius: "4px",
    border: "1px solid #eaeaea",
    cursor: "pointer",
    fontSize: "14px",
    color: "#555",
    background: "#fafafa",
    transition: "all 0.3s ease"
  },
  paymentActive: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "14px 16px",
    borderRadius: "4px",
    border: "1px solid #000000",
    background: "rgba(74, 90, 58, 0.04)",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    color: "#222"
  },
  radioHide: {
    display: "none"
  },
  btnOrder: {
    width: "100%",
    padding: "15px",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "13px",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "2px",
    cursor: "pointer",
    marginTop: "25px",
    background: "#ffffff",
    color: "#000000",
    border: "1px solid #000000",
    transition: "all 0.3s ease"
  },
  cartItemsList: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    maxHeight: "280px",
    overflowY: "auto",
    paddingRight: "4px"
  },
  verticalOrderItem: {
    display: "flex",
    gap: "14px",
    alignItems: "center"
  },
  productThumb: {
    width: "60px",
    height: "75px",
    objectFit: "cover",
    borderRadius: "2px",
    background: "#fafafa",
    boxShadow: "0 4px 10px rgba(0,0,0,0.03)"
  },
  productMainInfo: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "2px"
  },
  productName: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "16px",
    fontWeight: 500,
    color: "#222"
  },
  productTypeBadge: {
    fontSize: "11px",
    color: "#888",
    fontStyle: "italic"
  },
  productPriceMeta: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "2px"
  },
  productQuantityDisplay: {
    fontSize: "12px",
    color: "#666"
  },
  productPriceSum: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "13px",
    color: "#222",
    fontWeight: "500"
  },
  divider: {
    height: "1px",
    background: "rgba(74, 90, 58, 0.1)",
    margin: "20px 0"
  },
  couponSectionWrap: {
    display: "flex",
    gap: "8px",
    alignItems: "center"
  },
  couponInputInner: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    gap: "10px",
    background: "#fafafa",
    padding: "0 12px",
    borderRadius: "4px",
    border: "1px solid #eaeaea"
  },
  couponInputField: {
    width: "100%",
    height: "40px",
    border: "none",
    background: "transparent",
    outline: "none",
    fontSize: "13px",
    fontFamily: '"Montserrat", sans-serif'
  },
  btnApplyCoupon: {
    padding: "11px 16px",
    borderRadius: "4px",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "11px",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "1px",
    cursor: "pointer",
    whiteSpace: "nowrap"
  },
  costLinesBreakdown: {
    display: "flex",
    flexDirection: "column",
    gap: "12px"
  },
  miniCartItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "14px"
  },
  labelMuted: {
    color: "#666",
    fontWeight: 300
  },
  costValue: {
    color: "#222",
    fontWeight: 500
  },
  totalContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  totalFinalLabel: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "18px",
    fontWeight: 500,
    color: "#222",
    letterSpacing: "0.5px"
  },
  totalAmount: {
    fontFamily: '"Montserrat", sans-serif',
    color: "#000000",
    fontSize: "20px",
    fontWeight: 600
  },
  modalOverlay: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
    padding: "20px"
  },
  verificationCard: {
    background: "#fff",
    padding: "40px 35px",
    borderRadius: "4px",
    border: "1px solid rgba(74, 90, 58, 0.15)",
    maxWidth: "400px",
    width: "100%",
    textAlign: "center",
    boxSizing: "border-box",
    boxShadow: "0 20px 50px rgba(0,0,0,0.1)"
  },
  modalStatusTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    margin: "0 0 10px 0",
    fontSize: "22px",
    fontWeight: 400,
    color: "#222"
  },
  modalStatusDesc: {
    color: "#666",
    fontSize: "13px",
    lineHeight: "1.6",
    margin: 0
  },
  invoiceCard: {
    background: "#fff",
    padding: "40px 35px",
    borderRadius: "4px",
    border: "1px solid rgba(74, 90, 58, 0.15)",
    maxWidth: "460px",
    width: "100%",
    position: "relative",
    boxSizing: "border-box",
    boxShadow: "0 20px 50px rgba(0,0,0,0.1)"
  },
  closeBtn: {
    position: "absolute",
    top: "16px", right: "16px",
    background: "none", border: "none",
    cursor: "pointer", padding: 4
  },
  invoiceHeader: {
    textAlign: "center",
    marginBottom: "24px"
  },
  invoiceModalTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    margin: "12px 0 4px",
    fontSize: "22px",
    fontWeight: 500,
    color: "#222"
  },
  invoiceBody: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    background: "#fafafa",
    padding: "20px",
    borderRadius: "4px",
    border: "1px solid #eaeaea",
    fontSize: "14px"
  },
  invoiceRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#444"
  },
  qrSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "15px",
    marginTop: "15px",
    paddingTop: "15px",
    borderTop: "1px dashed rgba(74, 90, 58, 0.15)"
  },
  qrImage: {
    width: "180px",
    height: "180px",
    objectFit: "contain",
    border: "1px solid #eaeaea",
    padding: "6px",
    background: "#fff",
    borderRadius: "4px"
  },
  bankDetail: {
    textAlign: "center",
    fontSize: "13px",
    color: "#555",
    lineHeight: "1.5"
  },
  btnDone: {
    width: "100%",
    padding: "14px",
    border: "none",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "12px",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "2px",
    cursor: "pointer",
    marginTop: "25px"
  },
  toastNotification: {
    position: "fixed",
    top: "30px", right: "30px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "14px 22px",
    borderRadius: "4px",
    color: "#fff",
    boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
    zIndex: 3000
  },
  toastCloseBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: 0,
    marginLeft: "10px",
    display: "flex",
    alignItems: "center"
  }
};